import { captureException } from '@sentry/react';
import { Locale } from 'date-fns';
import { formatInTimeZone as originalTz, format as original } from 'date-fns-tz';
import {
  enUS,
  es,
  ptBR,
  zhCN,
  vi,
  ja,
  fr,
  de,
  ru,
  el,
  th,
  ko,
  arSA,
} from 'date-fns/locale';
import { LanguageCode } from 'domains/language';
import i18n from 'i18n';
import { isUndefined } from 'lodash';

export const LANGUAGE_LOCALE_MAP: Record<LanguageCode, Locale> = {
  'en-US': enUS,
  'ar-SA': arSA,
  'de-DE': de,
  'el-GR': el,
  'es-ES': es,
  'fil-PH': enUS,
  'fr-FR': fr,
  'hi-IN': enUS,
  'ja-JP': ja,
  'ko-KR': ko,
  'pt-BR': ptBR,
  'ru-RU': ru,
  'th-TH': th,
  'uk-UA': enUS,
  'vi-VN': vi,
  'zh-CN': zhCN,
};

const getLocale = (): Locale | undefined => {
  const languageCode = i18n.language;
  const locale = LANGUAGE_LOCALE_MAP[languageCode as LanguageCode];

  if (!locale) {
    // eslint-disable-next-line no-console
    console.warn(`Tried to format date in missing locale, code was: ${languageCode}`);
  }

  return locale;
};

/** Simple wrapper for the format function which loads locale from the i18n instance */
export const format: typeof original = (date, f, options) => {
  if (!isUndefined(options?.timeZone)) {
    captureException(
      'Silent error: bad usage of date format function, please use formatInTimeZone when dealing with timezone formats',
    );
  }
  return original(date, f, { ...options, locale: getLocale() });
};

/** Simple wrapper for the format function which loads locale from the i18n instance */
export const formatInTimeZone: typeof originalTz = (date, timezone, f, options) => {
  return originalTz(date, timezone, f, { ...options, locale: getLocale() });
};
